import { useState } from "react";

export interface SortingState {
  field: string | null;
  direction: "asc" | "desc" | null;
}

export const useSorting = () => {
  const [sortField, setSortField] = useState<string | null>(null);
  const [sortDirection, setSortDirection] = useState<"asc" | "desc" | null>(
    null,
  );

  const handleSort = (field: string) => {
    if (sortField === field) {
      if (sortDirection === "asc") {
        setSortDirection("desc");
      } else if (sortDirection === "desc") {
        setSortField(null);
        setSortDirection(null);
      } else {
        setSortDirection("asc");
      }
    } else {
      setSortField(field);
      setSortDirection("asc");
    }
  };

  const resetSorting = () => {
    setSortField(null);
    setSortDirection(null);
  };

  return {
    sortField,
    sortDirection,
    handleSort,
    resetSorting,
  };
};
